module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/images/background_vehicles_dark.926914bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/images/background_vehicles_dark.jpg
// module id = 1316
// module chunks = 16